
export const countriesData = [
    { value: "852", label: "+852" },
    { value: "853", label: "+853" },
    { value: "86", label: "+86" },
  ];
  